import {
  useBulkAddGroupField,
  useBulkDeleteGroupField,
  useBulkUpdateExposure,
  useBulkUpdateGroupField,
} from 'api/submission';
import { useParams } from 'react-router-dom';

type CacheAction =
  | 'bulkUpdateExposure'
  | 'bulkAddGroupField'
  | 'bulkUpdateGroupField'
  | 'bulkDeleteGroupField';

/**
 * Custom hook for managing bulk operations on exposures or group fields.
 *
 * @param {CacheAction[]} [updateCacheArray] - An optional array of actions names if action name is in updateCacheArray, cache will be updated after that action
 */
const useBulkExposuresOrGroupFields = (updateCacheArray?: CacheAction[]) => {
  const { id } = useParams() as { id: string };

  const isNeedToUpdateCache = (actionName: CacheAction) =>
    updateCacheArray ? updateCacheArray.includes(actionName) : false;

  const { mutateAsync: bulkUpdateExposure } = useBulkUpdateExposure(
    id,
    isNeedToUpdateCache('bulkUpdateExposure'),
  );

  const { mutateAsync: bulkAddGroupField } = useBulkAddGroupField(
    id,
    isNeedToUpdateCache('bulkAddGroupField'),
  );

  const { mutateAsync: bulkUpdateGroupField } = useBulkUpdateGroupField(
    id,
    isNeedToUpdateCache('bulkUpdateGroupField'),
  );

  const { mutateAsync: bulkDeleteGroupField } = useBulkDeleteGroupField(
    id,
    isNeedToUpdateCache('bulkDeleteGroupField'),
  );

  return {
    bulkUpdateExposure,
    bulkAddGroupField,
    bulkUpdateGroupField,
    bulkDeleteGroupField,
  };
};

export default useBulkExposuresOrGroupFields;
